// src/AddCampaign.tsx
import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import AddCampaignContent from './AddCampaignContent';

const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY!
);

const AddCampaign: React.FC = () => (
  <Elements stripe={stripePromise}>
    <AddCampaignContent />
  </Elements>
);

export default AddCampaign;
